import { IonIcon, IonSpinner } from '@ionic/react'
import { alertCircle } from 'ionicons/icons'
import React from 'react'
import { trpc } from '../../../../modules/trpc'

interface Props {
	interventionIds: string[]
}

const InterventionList: React.FC<Props> = ({ interventionIds }) => {
	const { data: interventions, isLoading } = trpc.eNode.interventions.getMany.useQuery(
		{ interventionIds },
		{ enabled: interventionIds.length > 0 }
	)

	if (interventionIds.length < 1) return null

	if (isLoading) return <IonSpinner name='crescent' />

	return (
		<div className='bg-red-300 mt-4 p-4 rounded-lg'>
			<IonIcon icon={alertCircle} className='w-full text-6xl mb-4' />
			<div className='space-y-4'>
				{interventions?.map((intervention, index) => (
					<div key={intervention.id}>
						<div className='text-xl font-bold mb-2'>{intervention.resolution.title}</div>
						<div
							className='description'
							dangerouslySetInnerHTML={{ __html: intervention.resolution.description ?? '' }}
						/>
						{index < interventions.length - 1 && (
							<div className='border-t border-red-400 mt-4'></div>
						)}
					</div>
				))}
			</div>
		</div>
	)
}
export default InterventionList
